import { apiGET, apiPOST } from '../utils/adapterFunctions'

export const getCasinoProviderToken = async (provider) => {
  return await apiGET(`/casino/provider/${provider}/token`, null, {
    hasNestedData: false,
  })
}

export const getCasinoDirectIntegrationUrl = async (isDemo, body) => {
  const gameType = isDemo ? 'demo-game' : 'game'
  return await apiPOST(`/casino/api/${gameType}/url`, body, {
    hasNestedData: false,
  })
}

export const getCasinoProviderUrl = async (allQueryParams) => {
  return await apiGET(allQueryParams, null, { hasNestedData: false })
}
